import { z } from "zod";
import { SAVED_VIEW_LAYOUTS } from "../constants.ts";
import {
  EntityTypeSchema,
  IsoDateTime,
  LocalIdSchema,
  PositionSchema,
  jsonColumn,
} from "./common.ts";
import { BoundedFilterSchema, ColumnStateSchema, SortSchema } from "./filter.ts";

export const SavedViewLayoutSchema = z.enum(SAVED_VIEW_LAYOUTS);

export const SavedViewSchema = z.object({
  id: LocalIdSchema,
  name: z.string().min(1).max(200),
  icon: z.string().max(64).nullable(),
  entity_type: EntityTypeSchema,
  query: jsonColumn(BoundedFilterSchema),
  columns: jsonColumn(z.array(ColumnStateSchema).max(200)).nullable().default(null),
  sort: jsonColumn(z.array(SortSchema).max(8)).nullable().default(null),
  layout: SavedViewLayoutSchema,
  folder_id: LocalIdSchema.nullable(),
  position: PositionSchema,
  created_at: IsoDateTime,
  updated_at: IsoDateTime,
});

export type SavedView = z.infer<typeof SavedViewSchema>;

export const SavedViewCreateSchema = z.object({
  name: z.string().trim().min(1).max(200),
  icon: z.string().max(64).nullable().optional(),
  entity_type: EntityTypeSchema.default("track"),
  query: BoundedFilterSchema,
  columns: z.array(ColumnStateSchema).max(200).nullable().optional(),
  sort: z.array(SortSchema).max(8).nullable().optional(),
  layout: SavedViewLayoutSchema.default("table"),
  folder_id: LocalIdSchema.nullable().optional(),
  after_id: LocalIdSchema.nullable().optional(),
  before_id: LocalIdSchema.nullable().optional(),
});

export type SavedViewCreate = z.infer<typeof SavedViewCreateSchema>;

export const SavedViewUpdateSchema = z
  .object({
    name: z.string().trim().min(1).max(200),
    icon: z.string().max(64).nullable(),
    query: BoundedFilterSchema,
    columns: z.array(ColumnStateSchema).max(200).nullable(),
    sort: z.array(SortSchema).max(8).nullable(),
    layout: SavedViewLayoutSchema,
    folder_id: LocalIdSchema.nullable(),
    after_id: LocalIdSchema.nullable(),
    before_id: LocalIdSchema.nullable(),
  })
  .partial();

export type SavedViewUpdate = z.infer<typeof SavedViewUpdateSchema>;
